const ServiceView = ({ color, className = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
    
      viewBox="0 0 24 24"
      fill="none"
      stroke={color || "#1E4387"}
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="lucide lucide-file-pen-line-icon lucide-file-pen-line size-5"
    >
      <path d="m18 5-2.414-2.414A2 2 0 0 0 14.172 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2" />
      <path d="M21.378 12.626a1 1 0 0 0-3.004-3.004l-4.01 4.012a2 2 0 0 0-.506.854l-.837 2.87a.5.5 0 0 0 .62.62l2.87-.837a2 2 0 0 0 .854-.506z" />
      <path d="M8 18h1" />
    </svg>
  );
};
export default ServiceView;
